import { CustomerStatus } from "../enums"

export class CustomerFilterOption {
    customerId: number
    customerCode: string
    firstName: string
    lastName: string
    email: string
    country: string
    countryId: number
    primaryShippingCountryID?: number
    searchKey: string
    customerIds: string[]
    ExportReport: boolean
    ReportHeader: string[] = []
    StartDate: Date
    EndDate: Date
    HomeCountry: number
    PreferredDeliveryCountry: number
    AccountStatus: number
    IncludeUnknownCustomer: boolean
    Status: CustomerStatus
    SendTo: string
}